import React from 'react';
import {
  Edit,
  SimpleForm,
  Toolbar,
  SaveButton,
  TextInput,
  useRecordContext,
  useNotify,
  useRedirect,
} from 'react-admin';
import { useParams } from 'react-router-dom';
import { Alert } from '@mui/material';
import { CourseEditLayout, CourseEditColumn, CourseEditSection } from './CourseEditLayout';
import { CourseContentInputs } from './CourseContentInputs';
import { CourseRevisionPanel, CourseHistoryPanel } from './CourseRevisionPanel';

const SeoCourseInputs = () => {
  const record = useRecordContext();
  if (!record?.seoRevision) return null;
  const revision = typeof record.seoRevision === 'string'
    ? JSON.parse(record.seoRevision)
    : record.seoRevision;
  return (
    <CourseEditLayout>
      <CourseEditSection>
        <Alert severity="info" sx={{ mb: 2 }}>
          Saving creates a course version for administrator review. The live
          course stays unchanged until approval.
        </Alert>
        <CourseRevisionPanel courseId={record.id} />
      </CourseEditSection>
      <CourseEditColumn>
        <TextInput source="companyName" label="Company" fullWidth disabled />
        <TextInput source="code" label="Code" fullWidth disabled />
      </CourseEditColumn>
      <CourseEditColumn>
        <CourseContentInputs seo locales={Object.keys(revision.current)} />
      </CourseEditColumn>
      <CourseEditSection>
        <CourseHistoryPanel courseId={record.id} />
      </CourseEditSection>
    </CourseEditLayout>
  );
};

export const SeoCourseEdit = (props) => {
  const { id } = useParams();
  const notify = useNotify();
  const redirect = useRedirect();
  return (
    <Edit
      {...props}
      id={decodeURIComponent(id)}
      mutationMode="pessimistic"
      actions={false}
      mutationOptions={{
        onSuccess: () => {
          notify('Version saved for review. The live course is unchanged.', {
            type: 'success',
          });
          redirect('list', 'courses');
        },
      }}
    >
      <SimpleForm
        toolbar={
          <Toolbar>
            <SaveButton />
          </Toolbar>
        }
      >
        <SeoCourseInputs />
      </SimpleForm>
    </Edit>
  );
};
